import { isUndefined } from 'lodash';

import fetch from 'utilities/fetch';
import { paths } from 'config/path_helpers';

export const analyticsSaveRecentFilters = (filters) => {
  fetch(paths.api.statisticRecentFilters(), {
    method: 'POST',
    body: JSON.stringify({ filters })
  });
};

export const createGradingRequestResponseRetry = (responseId: number, audioFile: Blob) => {
  return fetch(paths.api.aiGradingRequestResponseRetries(responseId), {
    method: 'POST',
    body: JSON.stringify({ responseRetry: { audioFile } })
  }).then((response) => {
    return response.responseRetry;
  });
};

export const fetchAnswers = (filters, page) => {
  return fetch(paths.api.answers(filters, page)).then((response) => {
    return response.answers;
  });
};

export const fetchAnswersSummary = (filters) => {
  return fetch(paths.api.answersSummary(filters)).then((response) => {
    return response.answers.summary;
  });
};

export const fetchGradingRequestResponseRetry = (responseId: number, retryId: number) => {
  return fetch(paths.api.aiGradingRequestResponseRetry(responseId, retryId)).then((response) => {
    return response.responseRetry;
  });
};

export const fetchPage = (path) => {
  const url = new URL(path, window.location.origin);
  const params = url.search;
  const jsonPath = `${url.pathname}.json${params}`;

  return fetch(jsonPath).then((response) => {
    return response;
  });
};

export const fetchPracticeSessions = (page) => {
  return fetch(paths.api.practiceSessions(page)).then((response) => {
    return response.practiceSessions;
  });
};

export const fetchStatistic = (name, filters) => {
  return fetch(paths.api.statistic(name, filters)).then((response) => {
    return response.statistic;
  });
};

export const fetchUserProfile = () => {
  return fetch(paths.api.userProfile()).then((response) => {
    return response.userProfile;
  });
};

export const finishMockTest = (id: number) => {
  return fetch(paths.api.mockTestFinish(id), {
    method: 'POST'
  }).then((response) => {
    return response.mockTest;
  });
};

export const regradeGradingRequestResponseRetry = (responseId: number, retryId: number) => {
  return fetch(paths.api.aiGradingRequestResponseRetryRegrade(responseId, retryId), {
    method: 'POST'
  }).then((response) => {
    return response.responseRetry;
  });
};

export const updateUserProfile = (userProfile) => {
  return fetch(paths.api.userProfile(), {
    method: 'PUT',
    body: JSON.stringify({ userProfile })
  }).then((response) => {
    return response.userProfile;
  });
};
